import HttpClient from "./index"
import ApiRoutes, { baseUrl } from "../config/endpoints"

export default class AuditAndCompliance extends HttpClient {
  constructor() {
    super(baseUrl)
    this._initializeRequestInterceptor()
  }

  // AuditAndCompliance
  auditData = ApiRoutes.AuditAndCompliance.AuditData
  complianceData = ApiRoutes.AuditAndCompliance.ComplianceData

  _initializeRequestInterceptor = () => {
    this.instance.interceptors.request.use(this._handleRequest)
  }

  _handleRequest = async (axiosConfig: any) => {
    return axiosConfig
  }

  getAuditData = (token: string, practiceSk: any) => {
    return this.instance({
      method: this.auditData.Method,
      url: this.auditData.EndPoint(practiceSk),
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
  }
  getComplianceData = (token: string, practiceSk: any) => {
    return this.instance({
      method: this.complianceData.Method,
      url: this.complianceData.EndPoint(practiceSk),
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
  }
}
